import React from 'react';
import { useNavigate } from 'react-router-dom';
import RestaurantHotspot from '../components/hotspots/RestaurantHotspot';
import KitchenHotspot from '../components/hotspots/KitchenHotspot';
import CasualHotspot from '../components/hotspots/CasualHotspot';
import FoodCourtHotspot from '../components/hotspots/FoodCourtHotspot';
import EmployeeDiningHotspot from '../components/hotspots/EmployeeDiningHotspot';
import BuffetHotspot from '../components/hotspots/BuffetHotspot';
import FoodTrucksHotspot from '../components/hotspots/FoodTrucksHotspot';

function Dining() {
  const navigate = useNavigate();

  return (
    <div className="page splash2 diningPage">
      <div className="page-header">On Site Dining</div>
      <div className="text-blocks">
        <div className="std-text">
          Whether your property offers fine dining restaurants, casual dining/food courts, grab n go, room service, poolside/beachside food &amp; beverage service, club/lounge or a combination of these, you need food &amp; beverage management solutions that meet all your needs for excellent customer service and successful food &amp; beverage management.
        </div>
      </div>
      <div className="logo" onClick={() => navigate('/aboutus/agilysys')}>
        <img src="/assets/casino/Agilysys-Logo.svg" alt="Agilysys" style={{width:'100%',height:'auto'}} />
      </div>
      <div className="tap">
        <img src="/assets/casino/solutions/Green-Touch-Icon.gif" alt="" />
        <div className="tap-prompt">
          Tap on each section of the map{'\n'}To drill into the details
        </div>
      </div>
      <div className="dining-map">
        <div className="restaurant">
          <RestaurantHotspot onClick={() => navigate('restaurant')} />
        </div>
        <div className="kitchen">
          <KitchenHotspot onClick={() => navigate('kitchen')} />
        </div>
        <div className="casual">
          <CasualHotspot onClick={() => navigate('casual')} />
        </div>
        <div className="food-court">
          <FoodCourtHotspot onClick={() => navigate('food-court')} />
        </div>
        <div className="employee-dining">
          <EmployeeDiningHotspot onClick={() => navigate('employee-dining')} />
        </div>
        <div className="buffet">
          <BuffetHotspot onClick={() => navigate('buffet')} />
        </div>
        <div className="food-trucks">
          <FoodTrucksHotspot onClick={() => navigate('food-trucks')} />
        </div>
      </div>
    </div>
  );
}

export default Dining;
